import {
    NavigationLayoutTypeEnum,
    NavigationPlacementEnum,
    NavigationVisualStyleEnum,
} from "@/scripts/common/enums.js";

export default {
    computed: {
        resolvedLogo() {
            return this.logo || this.$store?.state?.portfolio?.logo || null;
        },
        resolvedUserName() {
            return this.userName
                || this.resolvedLogo?.name
                || this.$store?.state?.user?.name
                || "";
        },
        upperCase() {
            return !!this.navigation?.menu?.upperCase;
        },
        logoClass() {
            return "navbar-logo";
        },
        showLogo() {
            if (this.hideLogo) return false;
            const layoutType = this.navigation?.layout?.layoutType;
            const supportsLogo =
                layoutType === NavigationLayoutTypeEnum.SIDES
                || layoutType === NavigationLayoutTypeEnum.SIMPLE_WITH_LOGO
                || layoutType === NavigationLayoutTypeEnum.SIDES_WITH_CTA
                || layoutType === NavigationLayoutTypeEnum.SPLIT_NAVIGATION
                || layoutType === NavigationLayoutTypeEnum.SPLIT_LOGO
                || layoutType === NavigationLayoutTypeEnum.CENTERED;
            return supportsLogo && !!this.resolvedLogo?.mode && this.navigation?.layout.position !== NavigationPlacementEnum.BOTTOM;
        },
        showCtaButton() {
            const layoutType = this.navigation?.layout?.layoutType;
            const ctaLayout =
                layoutType === NavigationLayoutTypeEnum.SIDES_WITH_CTA
                || layoutType === NavigationLayoutTypeEnum.SPLIT_NAVIGATION
                || layoutType === NavigationLayoutTypeEnum.SPLIT_LOGO;
            if (!ctaLayout) return false;
            return this.navigation?.cta?.show !== false;
        },
        showHamburger() {
            if (this.inline) return false;
            return !this.theme.includes("profile_theme_");
        },
        navItemGapStyle() {
            const itemGap = this.navigation?.layout?.itemGap;
            const resolvedGap = Number.isFinite(itemGap) ? itemGap : 24;
            return { "--navItemGap": `${resolvedGap}px` };
        },
        navFrameStyle() {
            const portfolio = this.viewData?.portfolio || this.$store?.state?.portfolio;
            const hasTightSiteMargin = portfolio?.templateSettings?.siteMargin === "TIGHT";
            const cornerRadius = Number(this.navigation?.moduleBackgroundSettings?.cornerRadiusPx);
            const resolvedRadius = Number.isFinite(cornerRadius) ? cornerRadius : 0;
            const isFramed = this.navigation?.layout?.visualStyle === NavigationVisualStyleEnum.FRAMED;
            const frameType = this.navigation?.moduleBackgroundSettings?.moduleBackgroundType;
            const hasOutline = frameType === "OUTLINE";
            const frameBgColor = this.resolveColorData(this.navigation?.moduleBackgroundSettings?.color);
            const frameOutlineColor = hasOutline
                ? this.resolveColorData(this.navigation?.moduleBackgroundSettings?.stroke?.color)
                : "transparent";

            return {
                "--navFrameRadius": `${resolvedRadius}px`,
                "--navFrameBgColor": frameBgColor,
                "--navFrameOutlineColor": frameOutlineColor,
                "--navFrameOutlineWidth": hasOutline ? "1px" : "0px",
                ...(hasTightSiteMargin ? { "--navFrameMarginInline": "-16px" } : {}),
                ...(isFramed ? { "--navCtaRadius": `${resolvedRadius === 16 ? 8 : resolvedRadius}px` } : {}),
            };
        },
    },
    methods: {
        resolveColorData(colorData) {
            if (!colorData) return null;

            if (Number.isFinite(colorData.paletteColorIndex)) {
                return this.colorPalette?.colors?.[colorData.paletteColorIndex] || null;
            }

            return colorData.color || null;
        },
    },
};
